import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ButtonDesign from "../ButtonDesign/ButtonDesign";

import "./PortfolioEmpty.css";

const PortfolioEmpty = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleNavigation = (page, serviceId) => {
		navigate("/" + page, {
			state: {
				serviceId: serviceId,
			},
		});
	};

	return (
		<div className="portfolio-empty-container">
			<h1 className="portfolio-empty-title">{t("portfolio.empty.title")}</h1>
			<h4 className="portfolio-empty-description">
				{t("portfolio.empty.description")}
			</h4>
			<div className="portfolio-empty-button">
				<ButtonDesign
					data={{
						text: t("portfolio.buttonMore"),
						icon: true,
						dynamic: false,
					}}
					handleClick={() => handleNavigation("servicios", "0")}
				/>
			</div>
		</div>
	);
};

export default PortfolioEmpty;
